import { createServerFn } from "@tanstack/react-start";
import { fetchHomeMakes } from "@/lib/home-makes.server";

export interface HomeMake {
  id: string;
  name: string;
  slug: string;
  model_count: number;
}

export const getHomeMakes = createServerFn({ method: "GET" }).handler(fetchHomeMakes);